import {
    type ErstelleNutzerRequest,
    type Nutzer,
    type PasswortAendernRequest,
    type PasswortZuruecksetzenAnfrageRequest,
    type SaveHortProCredentialsRequest
} from '@/js/model'
import type {
    TestHortProCredentialsRequest,
    TestHortProCredentialsResponse
} from '@/services/nutzer.service'

export const useNutzerStore = defineStore('nutzer', () => {
    const nutzers = ref<Nutzer[]>([])
    const service = useNutzerService()
    const { isLoading, isMethodLoading, loadingMethods, setLoading } = useLoading()

    const getNutzerById = (id: string): Nutzer | null => {
        const nutzer = nutzers.value.find((item) => (item as any).id === id)
        if (nutzer) {
            return nutzer
        } else {
            return null
        }
    }

    const fetchNutzerById = async (id: string): Promise<void> => {
        await setLoading('fetch', async () => {
            addOrReplaceNutzer(await service.getNutzerById(id))
        })
    }

    const saveHortProCredentials = async (request: SaveHortProCredentialsRequest): Promise<Nutzer> => {
        return await setLoading('saveHortProCredentials', async () => {
            const result = await service.saveHortProCredentials(request)
            addOrReplaceNutzer(result)

            return result
        })
    }

    const testHortProCredentials = async (
        request: TestHortProCredentialsRequest
    ): Promise<TestHortProCredentialsResponse> => {
        return await setLoading('testHortProCredentials', async () => {
            return await service.testHortProCredentials(request)
        })
    }

    const erstelleNutzer = async (request: ErstelleNutzerRequest): Promise<Nutzer> => {
        return await setLoading('erstelleNutzer', async (): Promise<Nutzer> => {
            const result = await service.erstelleNutzer(request)
            addOrReplaceNutzer(result)
            return result
        })
    }

    const passwortAendern = async (request: PasswortAendernRequest): Promise<Nutzer> => {
        return await setLoading('passwortAendern', async (): Promise<Nutzer> => {
            const result = await service.passwortAendern(request)
            addOrReplaceNutzer(result)
            return result
        })
    }

    const passwortZuruecksetzenAnfragen = async (request: PasswortZuruecksetzenAnfrageRequest): Promise<void> => {
        await setLoading('passwortZuruecksetzenAnfragen', async (): Promise<void> => {
            await service.passwortZuruecksetzenAnfragen(request)
        })
    }

    const addOrReplaceNutzer = (nutzer: Nutzer): void => {
        const index = nutzers.value.findIndex((item) => (item as any).id === (nutzer as any).id)

        if (index !== -1) {
            nutzers.value[index] = nutzer
        } else {
            nutzers.value.push(nutzer)
        }
    }

    return {
        nutzers,
        loadingMethods,
        isLoading,
        isMethodLoading,
        getNutzerById,
        fetchNutzerById,
        saveHortProCredentials,
        testHortProCredentials,
        erstelleNutzer,
        passwortZuruecksetzenAnfragen,
        passwortAendern
    }
})
